import styled from "styled-components";

const DividerStyled = styled.div`
   width: 100%;
   overflow: hidden;
  

   @media only screen and (min-width: ${props => props.theme.desktop}) {
      display: flex;
      gap: 3.2rem;
  }
`;


export { DividerStyled };
